import { getGlobals, getArchive } from "storyblok/api"
import Meta from "components/Meta"
import SimpleArchiveSection from "components/Archive/SimpleArchiveSection"
import InTheNewsCard from "components/InTheNewsCard"
import ArchiveHeader from "components/Archive/ArchiveHeader"
import { CardListSection } from "components/Archive/CardListSection"
import { getArchiveCommunityPostsApi } from "storyblok/inYourCommunityApi"
import { getCommunityPostsByCategory } from "storyblok/inYourCommunity"

export default function InYourCommunityArchive({ meta, story, items, perPage, total, currentPage }) {
  return (
    <>
      <Meta info={meta} />
      <main data-pagefind-ignore="all">
        <ArchiveHeader
          story={story?.content}
          breadcrumbs={[{ text: "In Your Community", href: "/in-your-community" }]}
        />
        <SimpleArchiveSection
          list={
            <CardListSection
              items={items}
              total={total}
              perPage={perPage}
              currentPage={currentPage}
              columns={3}
              handler={(params) => getArchiveCommunityPostsApi(params)}
              Card={InTheNewsCard}
            />
          }
        />
      </main>
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()

  const story = await getArchive("in-your-community", preview)

  const { items, currentPage, total, perPage } = await getCommunityPostsByCategory()

  return {
    props: {
      story: story ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      items,
      currentPage,
      total,
      perPage,
      globals: globals ?? null,
      preview,
    },
  }
}
